import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input, Prefix } from 'web-ui-components/lib/atoms/forms';
import { FieldBody, ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import { CHAPS_IFT_BACS_AmountLimit } from '../../../../config';
import withValidation from '../../../../containers/withValidation';
import {
	fixAmount,
	isAmountWithinLimit,
	sanitizeDecimalOccurrences,
	stripCurrencysIllegalCharacters,
} from '../../../../helpers/fieldHelpers';
import styles from '../BacsPaymentStyles';

class Amount extends Component {
	constructor(props) {
		super(props);
		this.state = { amount: this.props.amount };
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.amount !== nextProps.amount) this.setState({ amount: nextProps.amount });
	}

	handleOnBlur(event) {
		const amount = fixAmount(event.target.value);
		this.setState({ amount });
		if (this.props.onBlur) {
			this.props.onBlur(amount);
		}
	}

	handleChange(event) {
		const amount = stripCurrencysIllegalCharacters(event.target.value);
		const sanitizedAmount = sanitizeDecimalOccurrences(amount);

		if (isAmountWithinLimit(sanitizedAmount, CHAPS_IFT_BACS_AmountLimit)) {
			this.setState({ amount: sanitizedAmount });
		}
	}

	render() {
		const {
			id,
			isValid,
			showValidation,
			invalidMessage,
			isMaxLimitExceeded,
			maxLimitExceededMessage,
			showMaxLimitError,
			onFocus,
			biocatchIdentifier,
		} = this.props;

		const errorMsgVisible = (!isValid && showValidation) || (showMaxLimitError && isMaxLimitExceeded);

		const { amount } = this.state;

		return (
			<div>
				<FieldBody>
					<Prefix>£</Prefix>
					<Input
						id={`field-amount-${id}`}
						data-bb={biocatchIdentifier}
						type="text"
						hasPrefix
						required
						value={amount}
						onChange={this.handleChange}
						onBlur={this.handleOnBlur}
						onFocus={onFocus}
						className={styles.main__input}
						data-test-id={'field-amount'}
					/>
				</FieldBody>
				{errorMsgVisible && (
					<div className={styles.main__validation}>
						<ValidationMessage hasIcon={false} value={isMaxLimitExceeded ? maxLimitExceededMessage : invalidMessage} />
					</div>
				)}
			</div>
		);
	}
}

Amount.propTypes = {
	id: PropTypes.string.isRequired,
	amount: PropTypes.string,
	onBlur: PropTypes.func.isRequired,
	onFocus: PropTypes.func.isRequired,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	invalidMessage: PropTypes.string.isRequired,
	isMaxLimitExceeded: PropTypes.bool,
	maxLimitExceededMessage: PropTypes.string,
	showMaxLimitError: PropTypes.bool,
};

export { Amount };
export default withValidation({ validations: ['required', 'amount'], key: 'amount' })(Amount);
